import { useState } from 'react';
import { X } from 'lucide-react';

export default function AnnouncementBanner() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <div className="relative bg-navy-900 border-b border-white/10 text-sm px-4 py-2.5 flex items-center justify-center">
      <p className="text-center leading-snug">
        <span className="text-white/55">Aura-Triage is now in pilot —</span>{' '}
        <a
          href="/solutions/aura-triage.html"
          className="font-semibold text-primary-400 underline underline-offset-2 hover:text-primary-300 transition-colors"
        >
          Fax inbox, sorted by urgency →
        </a>
      </p>
      <button
        onClick={() => setVisible(false)}
        className="absolute right-3 sm:right-4 text-white/40 hover:text-white/80 p-1 transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
